module.exports = require('./helpers/bundle-url').getBundleURL('3ZIKl') + "logo-dark.eefe0b7f.svg";